import React from "react";
import { titles } from "../components/PrivacyPolicy";

const PrivacyPolicy = () => {
  return (
    <div>
      {titles.map((item) => (
        <div key={item.id} className="privacy__policy">
          <h3 className="privacy__title">{item.title}</h3>
          <p className="privacy__text">{item.desc}</p>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
